import React, { useState, useEffect } from 'react';
import axios from "axios";
import { withRouter, useLocation, useHistory } from 'react-router-dom';
import {
    GridComponent, ColumnsDirective, ColumnDirective,
    Inject, Page, Sort, Toolbar
} from "@syncfusion/ej2-react-grids";
import { getValue } from '@syncfusion/ej2-base';

const PetsMember = () => { debugger;
    const history = useHistory();  
    const location = useLocation();        
    const [customerPet, setCustomerPet] = useState([]);
    
    useEffect(() => {
        axios
            .get(`${process.env.REACT_APP_BACKEND_BASE_URL}/PetInformation/GetByCustomerId/` + location.state.cId)
            .then((response) => {
                setCustomerPet(response.data);
            });
    }, []);
    
    const valueAccess = (field, data, column) => {
        return data[field] + ' yr, ' + getValue('ageMonth', data) + ' mo';
    };

    const template = args => {  
        let src = process.env.REACT_APP_IMAGE_URL + args.imageName;
        return (<div className='pet-img'><img src={src} alt={args.petName} /></div>);
    };
    
    const toolbarOptions = [
        "Search"
    ];    

    return (
        <div className="int-container">
            <div class="container">
                <div class="form-container-large" style={{ width: "100%" }}>
                    <div class="form-group">
                        <button
                            className="back e-icons e-back e-btn e-flat e-icon-btn"
                            title="Back"
                            onClick={() => history.goBack()}
                        ></button>    
                    </div>
                    <div class="form-group">
                        <h3 style={{ color: "#f19f1f", width: "100%", textAlign: "center" }}>Pets</h3>
                    </div>
                    <div id='grdAdmin'>
                        <strong>{location.state.fName + ' ' + location.state.lName}</strong>
                        <GridComponent dataSource={customerPet} allowSorting={true} height='auto' toolbar={toolbarOptions} >                        
                            <ColumnsDirective>
                                <ColumnDirective field="petID" headerText="Pet Id" width="50" textAlign="left" visible={false} />
                                <ColumnDirective field="petName" headerText="Pet Name" width="100px" textAlign="left" />                                
                                <ColumnDirective headerText="Image" template={template} width="100px" />                                
                                <ColumnDirective field="ageYear" headerText="Age" width='100' textAlign="left" valueAccessor={valueAccess} />
                                <ColumnDirective field="weight" headerText="Weight(lb)" width="100" textAlign="left" />                                                              
                            </ColumnsDirective>
                            <Inject services={[Page, Sort, Toolbar]} />
                        </GridComponent>
                    </div>                    
                </div>
            </div>
        </div>
    );
}

export default withRouter(PetsMember);